// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-navigation-empty-state__action {
  margin-top: var(--g-spacing-5);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/components/EmptyState/EmptyState.scss"],"names":[],"mappings":"AACI;EACI,8BAAA;AAAR","sourcesContent":[".dl-navigation-empty-state__action {\n  margin-top: var(--g-spacing-5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
